import _get from "lodash/get";
import _keyBy from "lodash/keyBy";
import {debug} from '../../util/service';
import {formatResponseData} from "../../util/format";
import {newsletterState as sampleNewsletterState} from "../samples/newsletterState";

const initialState = {
    availableNewsletters: {}, // The response from the list of newsletter for this access token, keyed by grouping ID
    newslettersError: "", // The error associate with the service above
    archives: [], // The archives of the most recently seen publication
    archivesError: "", // The error associate with the service above
    currentData: {}, // The data for the most recent publication
    currentDataError: "", // The error associate with the service above
    error: "",
    isTemporary: false, // is the curent newsletter temporary
    isLoadingNewsletterData: true,
};

export default (state = initialState, action) => {
    let array; // Use this variable in the reducer below if you need it (to help with transformations)
    switch(action.type){
        case "newsletters/LOAD_NEWSLETTERS_SUCCESS":
            array = _get(action, "payload", []);
            return {
                ...state,
                availableNewsletters: _keyBy(array, "groupingId"),
            };
        case "newsletters/LOAD_NEWSLETTER_DATA_START":
            return {
                ...state,
                isLoadingNewsletterData: true
            };
        case "newsletters/LOAD_NEWSLETTER_DATA_SUCCESS":
            return {
                ...state,
                currentData: formatResponseData(action.payload),
                isLoadingNewsletterData: false,
                isTemporary: false
            };
        case "newsletters/LOAD_TEMPORARY_NEWSLETTER_DATA_SUCCESS":
            return {
                ...state,
                currentData: formatResponseData(action.payload),
                isLoadingNewsletterData: false,
                isTemporary: true
            };
        case "newsletters/LOAD_AVAILABLE_ARCHIVES_SUCCESS":
            return {
                ...state,
                archives: action.payload
            };
        case "newsletters/LOAD_NEWSLETTERS_ERROR":
            return {
                ...state,
                newslettersError: action.payload
            };
        case "newsletters/LOAD_NEWSLETTER_DATA_ERROR":
        case "newsletters/LOAD_TEMPORARY_NEWSLETTER_DATA_ERROR":
            return {
                ...state,
                isLoadingNewsletterData: false,
                currentDataError: action.payload
            };
        case "newsletters/LOAD_AVAILABLE_ARCHIVES_ERROR":
            return {
                ...state,
                archivesError: action.payload
            };
        default:
            return state;
    }
};
